"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTradeCashflow = void 0;
const react_1 = require("react");
const common_business_1 = require("@pionex-web-kit/common-business");
const FutureAPI_1 = require("./../../apis/FutureAPI");
const utils_1 = require("./../../utils");
/**账户资金流水 */
const useTradeCashflow = ({ filter, limit = 20 }) => {
    const [cashflows, setCashflows] = (0, react_1.useState)();
    const [hasMore, setHasMore] = (0, react_1.useState)(true);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [isRefreshing, setIsRefreshing] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)();
    const innerState = (0, react_1.useRef)({});
    // 请求开始
    const loadStart = (forceRefresh, withoutLoading) => {
        if (!withoutLoading) {
            if (forceRefresh) {
                setIsRefreshing(true);
            }
            else {
                setLoading(true);
            }
        }
        if (forceRefresh) {
            // 强制刷新，就清空分页数据
            innerState.current.nextPageToken = undefined;
        }
        setError(undefined);
        innerState.current.isFetching = true;
    };
    // 请求结束
    const loadEnd = (forceRefresh, withoutLoading) => {
        if (!withoutLoading) {
            if (forceRefresh) {
                setIsRefreshing(false);
            }
            else {
                setLoading(false);
            }
        }
        innerState.current.isFetching = false;
    };
    // 清空所有状态
    const clear = (0, react_1.useCallback)(() => {
        innerState.current = {};
        setIsRefreshing(false);
        setLoading(false);
        setHasMore(true);
        setCashflows(undefined);
        setError(undefined);
    }, []);
    const loadMore = (0, common_business_1.usePersistFn)((forceRefresh, withoutLoading) => {
        // 正在请求中，直接返回
        if (innerState.current.isFetching) {
            return;
        }
        // 加载下一页，但是没有更多数据了，直接返回
        if (!forceRefresh && !hasMore) {
            return;
        }
        loadStart(forceRefresh, withoutLoading);
        (0, FutureAPI_1.queryTradeCashflowApi)({
            page_token: innerState.current.nextPageToken || "",
            cashflow_type: filter !== "all" ? filter : undefined,
            limit,
        }).subscribe({
            next: (res) => {
                const hasMore = Boolean(res.page_token);
                setHasMore(hasMore);
                innerState.current.nextPageToken = res.page_token;
                const newData = (res.cashflows || []).map((item) => (0, utils_1.formatCashflow)(item));
                if (forceRefresh) {
                    setCashflows(newData);
                }
                else {
                    setCashflows((histories = []) => histories === null || histories === void 0 ? void 0 : histories.concat(newData));
                }
                setError(undefined);
                loadEnd(forceRefresh, withoutLoading);
            },
            error: (err) => {
                setError(err);
                setHasMore(false);
                loadEnd(forceRefresh, withoutLoading);
            },
        });
    });
    const refresh = (0, react_1.useCallback)(() => {
        loadMore(true);
    }, [loadMore]);
    (0, common_business_1.useUpdateEffect)(() => {
        loadMore();
    }, [filter]);
    return {
        data: cashflows,
        clear,
        error,
        loadMore,
        refresh,
        hasMore,
        loading,
        isRefreshing,
    };
};
exports.useTradeCashflow = useTradeCashflow;
